export default {
    accounts (state) {
      return state.accounts
    },

    selectedAccount (state) {
        return state.selectedAccount
    },

    getAccount: state => (faqId) => {
      return state.accounts();
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/getters.js